import { Divider } from "@ps-design-system/components/Divider";

import { TaxDetailsAddOnsNote } from "./TaxDetailsAddOnsNote";
import { TaxDetailsBanner } from "./TaxDetailsBanner";
import { TaxDetailsDeleteModal } from "./TaxDetailsDeleteModal";
import { TaxDetailsDescription } from "./TaxDetailsDescription";
import { TaxDetailsHeader } from "./TaxDetailsHeader";
import { useTaxDetails } from "./TaxDetailsProvider";
import { TaxInvoicesList } from "./TaxInvoices";

/**
 * Renders the Tax Details section: heading, explainer copy and one banner per
 * tax registration the guest's region offers.
 */
const TaxDetails = () => {
  const { registrations } = useTaxDetails();

  return (
    <div className="tw-flex tw-flex-col tw-gap-32">
      <div className="tw-flex tw-flex-col tw-gap-16">
        <TaxDetailsHeader />
        <Divider className="tw-m-0" />
        <TaxDetailsDescription />
        {registrations.map((registration) => (
          <TaxDetailsBanner
            key={`${registration.taxTypes.join("-")}-${String(
              registration.isSubregion,
            )}`}
            registration={registration}
          />
        ))}
        <TaxDetailsAddOnsNote />
        <TaxDetailsDeleteModal />
      </div>
      <TaxInvoicesList />
    </div>
  );
};

export { TaxDetails };
